import { Controller } from "@hotwired/stimulus";

// Fired by Turbo/idiomorph on every element it reconciles during a morph refresh, target = the
// element that was morphed. A refused save re-renders the form through Turbo without firing a
// page-load event, so this element survives the morph and connect() never re-runs — the same
// problem form-select-controller.ts and searchable-select-controller.ts already solve. Re-apply
// the visible case (and the select's width) on this event too.
const MORPH_ELEMENT_EVENT = "turbo:morph-element";

export default class extends Controller {
   static targets = ["select", "case"];

   declare readonly selectTarget: HTMLSelectElement;
   declare readonly caseTargets: HTMLElement[];

   private readonly handleMorphElement = (event: Event): void => {
      if (event.target !== this.element) return;
      this.apply();
   };

   connect() {
      this.element.addEventListener(MORPH_ELEMENT_EVENT, this.handleMorphElement);
      this.apply();
   }

   disconnect() {
      this.element.removeEventListener(MORPH_ELEMENT_EVENT, this.handleMorphElement);
   }

   onChange() {
      this.apply();
   }

   // `hidden` takes a branch out of the tab order without taking its fields out of the DOM, so
   // hidden branches keep posting. `data-spans-row` is the dropdown's width switch; the rule it
   // drives lives in src/Tailwind/Components/branching-select.css.
   private apply(): void {
      // Read the option by value rather than by `selectedIndex`: the `selected` attribute sets the
      // select's initial `.value` on parse, but not every DOM implementation back-fills
      // `selectedIndex` from it before script runs.
      const selectedValue = this.selectTarget.value;
      const selectedOption = Array.from(this.selectTarget.options).find((option) => option.value === selectedValue);
      const hasContent = selectedOption?.dataset.hasContent === "true";

      for (const caseElement of this.caseTargets) {
         caseElement.hidden = caseElement.dataset.branchingSelectCaseValue !== selectedValue;
      }

      this.selectTarget.dataset.spansRow = String(!hasContent);
   }
}
